import Auth from '../../../modules/Auth'
import Global from '../../../constants/Global'
export function fetchMyPointSum({ commit }) {
  fetch(Global.getServerDomain() + `/profile/pointsum`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'auth_key': Auth.getToken()
    }
  })
    .then(function (res) {
      return res.json()
    })
    .then(function (payload) {
      commit('my_pointsum', payload.myPointsum)
    })
    .catch(error => console.error(error))
}
export function fetchMyEarnedPoints({ commit }) {
  fetch(Global.getServerDomain() + `/profile/earnedpoints`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'auth_key': Auth.getToken()
    }
  })
    .then(function (res) {
      return res.json()
    })
    .then(function (payload) {
      commit('my_earned_pointsum', payload.myEarnedPointsum)
    })
    .catch(error => console.error(error))
}
export function fetchMySpentPoints({ commit }) {
  fetch(Global.getServerDomain() + `/profile/spentpoints`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'auth_key': Auth.getToken()
    }
  })
    .then(function (res) {
      return res.json()
    })
    .then(function (payload) {
      commit('my_spent_pointsum', payload.mySpentPointsum)
    })
    .catch(error => console.error(error))
}

export async function fetchMyPoints({ commit, getters }) {
  const result = await new Promise(resolve => {
    try {
      fetch(Global.getServerDomain() + `/profile/points`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'auth_key': Auth.getToken()
        }
      })
        .then(function (res) {
          resolve(res.json())
        })
    } catch (error) {
      console.log(error);
    }
  })
  const myPoints = []
  let rowIndex = result.length - 1
  let bal = 0;
  let itemId = 0;
  let str = "";
  result.forEach(function (element, index) {
    const item = {}
    item.Date = element.createdAt
    item.Amount = element.value
    if (element.sUser_to) {
      item.Partner = element.sUser_to.username
      item.Partner_id = element.sUser_to.id
    } else {
      item.Partner = 'Swampum system'
      item.Partner_id = 0
    }
    if (item.Partner === getters.getUser.username) {
      if (element.sUser_from) {
        item.Partner = element.sUser_from.username
        item.Partner_id = element.sUser_from.id
      } else {
        item.Partner = 'Swampum system'
        item.Partner_id = 0
      }
    } else {
      item.Amount = item.Amount * -1
    }
    if (element.message) {
      item.Note = element.message
    } else {
      item.Note = "BONUS: default"
    }
    item._showDetails = false
    item.index = rowIndex
    rowIndex--
    if (item.Note && element.sUser_from) {
      item.Note = `ITEM: ${item.Note}`;
    }
    if (index === 0) {
      bal = item.Amount
    } else if (index === result.length - 1 || index > 0) {
      bal += item.Amount
    }
    if(item.Amount > 0) item.Trade = "Earned"
    else item.Trade = "Spent"
    if (item.Note === "BONUS: New account registration") {
      item.Type = "BONUS"
      item.Action = "Old new account";
    } else {
      if(item.Note.substring(0, item.Note.indexOf(":")) === "BONUS") {
        item.Type = "BONUS"
        if(item.Note.includes("was added") || item.Note.includes("item added")) {
          item.Action = "Item added";
          str = item.Note.substring(item.Note.indexOf("item-details"), item.Note.lastIndexOf('"'));
          itemId = str.substring(str.lastIndexOf("/") + 1);
          item.ItemID = parseInt(itemId);
          if(isNaN(item.ItemID)) delete item.ItemID;
        }  else if (item.Note.includes("BONUS: Email invitation")) {
          item.Action = "New invitation"
          const aux = item.Note.split(' ');
          item.FriendInvited = aux[aux.length - 1];
        }
      } else {
        item.Type = "ITEM"
        str = item.Note.substring(item.Note.indexOf("item-details"), item.Note.lastIndexOf('"'));
        itemId = str.substring(str.lastIndexOf("/") + 1);
        item.ItemID = parseInt(itemId);
        if(isNaN(item.ItemID)) delete item.ItemID;
      }
    }
    item.Total = bal;
    myPoints.push(item)
  })
  myPoints.reverse();
  commit('my_points', myPoints)
  // fetch(Global.getServerDomain() + `/profile/points`, {
  //   method: 'GET',
  //   headers: {
  //     'Content-Type': 'application/json',
  //     'auth_key': Auth.getToken()
  //   }
  // })
  //   .then(function (res) {
  //     return res.json()
  //   })
  //   .then(function (payload) {
  //     var myPoints = []
  //     var rowIndex = payload.length - 1
  //     payload.forEach(function (element) {
  //       var item = {}
  //       var date = new Date(element.createdAt)
  //       item.Time = formatDate(date)
  //       item.Points = element.value
  //       item.Partner = element.sUser_to.username
  //       item.Partner_id = element.sUser_to.id
  //       if (item.Partner === getters.getUser.username) {
  //         if (element.sUser_from) {
  //           item.Partner = element.sUser_from.username
  //           item.Partner_id = element.sUser_from.id
  //         } else {
  //           item.Partner = 'Swampum system'
  //           item.Partner_id = 0
  //         }
  //       } else {
  //         item.Points = item.Points * -1
  //       }
  //       item.Note = element.message
  //       item._showDetails = false
  //       item.index = rowIndex
  //       rowIndex--
  //       if (item.Note && element.sUser_from) {
  //         item.Note = element.sUser_from.username + ': ' + item.Note
  //       }
  //       myPoints.push(item)
  //     }, this)
  //     commit('my_points', myPoints)
  //   })
  //   .catch(error => console.error(error))
}

export async function transferPoint({ commit, dispatch }, { to_id, from_id, value, note }) {
  const result = await new Promise(resolve => {
    fetch(Global.getServerDomain() + `/profile/points/transfer`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': Auth.getToken()
      },
      body: JSON.stringify({
        toId: to_id,
        fromId: from_id,
        points: value,
        note: note
      })
    })
      .then(function (res) {
        resolve(res.json())
      })
      .catch(error => console.error(error))
  });
  commit('transfer_point', result)
  dispatch('fetchMyPointSum')
  return result;
}

export async function checkPosterAvailablePointSum(commit, {itemId}) {
  return await new Promise(resolve => {
    fetch(Global.getServerDomain() + `/profile/points/check_sum/${itemId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': Auth.getToken()
      },
    }).then((res) => {
      resolve(res.json())
    }).catch(error => console.error(error))
  })
}
